<template>
  <section class="sec" :id="id">
    <div ref="ghostEl" class="sec__ghost" aria-hidden="true">{{ num }}</div>
    <div class="sec__inner">
      <header class="sec__head">
        <p class="eyebrow" v-reveal>Chapter {{ num }} — {{ kicker }}</p>
        <h2 class="sec__title" v-reveal="60">
          <slot name="title" />
        </h2>
        <div class="sec__lede lede" v-reveal="140">
          <slot name="lede" />
        </div>
      </header>
      <div class="sec__body">
        <slot />
      </div>
    </div>
  </section>
</template>

<script setup>
import { useParallax } from '../../composables/useParallax'

defineProps({
  id: { type: String, required: true },
  num: { type: String, required: true },
  kicker: { type: String, required: true }
})

const ghostEl = useParallax(1.4)
</script>

<style scoped>
.sec {
  position: relative;
  z-index: 2;
  padding: clamp(90px, 13vh, 170px) var(--gutter);
  scroll-margin-top: 60px;
}

.sec__ghost {
  position: absolute;
  top: 0;
  right: clamp(8px, 3vw, 60px);
  font-family: var(--font-display);
  font-weight: 700;
  font-size: clamp(140px, 26vw, 400px);
  line-height: 0.78;
  letter-spacing: -0.05em;
  color: transparent;
  -webkit-text-stroke: 1px rgba(255, 255, 255, 0.055);
  transform: translate3d(0, var(--shift, 0px), 0);
  pointer-events: none;
  user-select: none;
  will-change: transform;
}

.sec__inner {
  position: relative;
  max-width: 1240px;
  margin: 0 auto;
}

.sec__head { max-width: 900px; margin-bottom: clamp(44px, 6vh, 76px); }

.sec__title {
  font-size: clamp(32px, 4.2vw, 60px);
  font-weight: 500;
  margin-bottom: 26px;
}
.sec__title :deep(.hl) {
  color: var(--light);
}
.sec__title :deep(.sig) {
  color: var(--signal);
}

.sec__lede :deep(p) { max-width: 64ch; }
</style>
